import { Link, LinkProps } from '@hover/blueprint';
import React, { ReactNode } from 'react';

interface LinkExternalProps extends Omit<LinkProps, 'children'> {
  children?: ReactNode;
}

const LinkExternal = ({ children, ...props }: LinkExternalProps) => (
  <Link {...props} rel="noopener noreferrer" target="_blank">
    {children ?? ''}
  </Link>
);

export { LinkExternal };
